import { graphConfig } from "../authConfig";
import { IPublicClientApplication } from "@azure/msal-browser";
import { BaseService } from "./BaseService";

export interface ITileData {
    tiles: ITile[];
    tabsEnabled?: boolean;
}

export interface ITile {
    appUrl?: string;
    name: string;
    title: string;
    webUrl?: string;
    subTitle?: string;
    tags?: string[];
    category?: string[];
}

export interface IKeySitesData {
    appUrl?: string;
    name: string;
    title: string;
    webUrl?: string;
    subTitle?: string;
    tags?: string[];
}

export class TileService extends BaseService {

    public getKeySitesData = async (instance: IPublicClientApplication) => {
        
        const headers = await this.getAuthorizedRequestHeaders(instance);
        const options = {
            method: "GET",
            headers: headers
        };

        const tileData = await fetch(`${graphConfig.keySitesEndpoint}`, options)
            .then(response => {
                return response.json();
            }).catch(error => console.log(error));

        return tileData as IKeySitesData[];
    }

    public getTileData = async (instance: IPublicClientApplication, forceRacc: boolean, forceDirectorate: string = "", forceServiceArea: string = "") => {

        const headers = await this.getAuthorizedRequestHeaders(instance);
        const options = {
            method: "GET",
            headers: headers
        };

        const effectiveForceRacc = forceRacc && !forceDirectorate;
        const effectiveDirectorate = forceDirectorate && !effectiveForceRacc ? forceDirectorate : "";
        const effectiveServiceArea = effectiveDirectorate && forceServiceArea ? forceServiceArea : "";
        const directorateOverride = effectiveDirectorate ? `&forceDirectorate=${encodeURIComponent(effectiveDirectorate)}` : "";
        const serviceAreaOverride = effectiveServiceArea ? `&forceServiceArea=${encodeURIComponent(effectiveServiceArea)}` : "";
        const tileData = await fetch(`${graphConfig.tilesEndpoint}?forceRacc=${effectiveForceRacc}${directorateOverride}${serviceAreaOverride}`, options)
            .then(response => response.json()).catch(error => console.log(error));

        return tileData as ITileData;
    }
}